


























































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";
import BirthdaysBirthdayDetails from "./BirthdaysBirthdayDetails.vue";

import BirthdayStaffAvailableJson from "../../shared/BirthdayStaffAvailableJson";
import UserJson from "../../shared/UserJson";

import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "BirthdaysAll",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    BirthdaysBirthdayDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    BirthdayBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      birthdayBookings: null as BirthdayBookingJson[] | null,
      birthdayBookingsMoreAvailable: null as boolean | null,
      useFilters: false as boolean,
      filterDate: "" as string,
      cachedFilterDate: "" as string,
      searchString: null as string | null,
      allUsers: null as UserJson[] | null,
      staffAvailable: null as BirthdayStaffAvailableJson[] | null,
      BirthdayStaffAvailableStatus: {
        open: "Frei zur Buchung",
        reserved: "Reserviert",
        booked: "Gebucht",
      },
      selectedBirthdayId: null as number | null,
      selectedBirthday: null as BirthdayBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadBirthdayBookings();
      this.loadAllUsers();

      if (this.useFilters) {
        this.initStaffSection();
      }
    },

    async reloadSelectedBirthday() {
      this.selectedBirthday = null;
      this.toggleDetails();
      if (this.selectedBirthdayId != null) {
        try {
          this.selectedBirthday = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);
          this.openDetails(this.selectedBirthday, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadBirthdayBookings(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.birthdayBookings = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var afterDateTime = null;
      var beforeDateTime = null;
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        //show birthdays with specific date
        if (this.filterDate != "") {
          afterDateTime = new Date(this.filterDate);
          beforeDateTime = new Date(afterDateTime);
          beforeDateTime.setDate(afterDateTime.getDate() + 1);
        }
      }

      //load more
      if (loadMore && this.birthdayBookings != null) {
        this.birthdayBookingsMoreAvailable = null;
        skipAmount = this.birthdayBookings.length;
      } else {
        this.birthdayBookings = null;
      }

      //final load birthdays
      if (this.restClient != null) {
        try {
          let birthdays = await this.restClient.getBirthdayBookings(
            null,
            null,
            afterDateTime,
            beforeDateTime,
            this.searchString,
            "DESC",
            skipAmount
          );

          if (loadMore && this.birthdayBookings != null) {
            this.birthdayBookings = this.birthdayBookings.concat(birthdays.birthdayBookings);
          } else {
            this.birthdayBookings = birthdays.birthdayBookings;
          }

          this.birthdayBookingsMoreAvailable = birthdays.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    /*
    permissionAble: function(item: BirthdayBookingJson) {
      if (
        this.loginPermission > item.permissionRank ||
        this.loginPermission == this.UserPermissionRank.admin ||
        this.loginId == item.ID
      ) {
        return true
      } else {
        return false
      }
    },
*/

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadBirthdayBookings();
      //todo: Bei mehr Filtern muss womoeglich geprueft werden, was gefiltert wurde
      this.initStaffSection();
    },

    removeUseFilters() {
      this.useFilters = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadBirthdayBookings();
    },

    setFilterDate() {
      var filterDate = "";

      if (this.cachedFilterDate) {
        if (this.supportsDatePicker) {
          filterDate = DateFormatter.formatUSDate(new Date(this.cachedFilterDate));
        } else {
          if (this.cachedFilterDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedFilterDate);

            if (d != null) {
              filterDate = DateFormatter.formatUSDate(d);
            }
          }
        }
      }

      this.filterDate = filterDate;
    },

    initStaffSection() {
      this.loadStaffAvailable();
    },

    async loadAllUsers() {
      this.allUsers = null;
      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadStaffAvailable() {
      this.staffAvailable = null;
      try {
        this.staffAvailable = await this.restClient.getBirthdayStaffAvailability();
      } catch (e) {
        alert(e.message);
      }
    },

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "--";
      }
    },

    resetSearchString() {
      this.searchString = "";
      this.loadBirthdayBookings();
    },

    openDetails(item: BirthdayBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedBirthdayId = item.ID;
      } else {
        this.selectedBirthdayId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },

    cachedFilterDate: function () {
      this.setFilterDate();
    },
  },
  computed: {
    birthdayColumns: function (): TableViewColumnDefinitions<BirthdayBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Kind)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Programm",
          td: (i) => i.programTitle,
        },
        {
          th: "Ort",
          td: (i) => i.location,
        },
        {
          th: "Betreuer:in",
          td: (i) => vue.getStaffFullName(i.staffId),
        },
        {
          th: "Status",
          td: (i) => vue.BirthdayBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<BirthdayBookingJson>[];
    },

    dateStaffAvailable(): BirthdayStaffAvailableJson[] | null | undefined {
      if (this.staffAvailable != null) {
        let atDate = new Date(this.filterDate);
        let atDateEnd = new Date(atDate);
        atDateEnd.setDate(atDateEnd.getDate() + 1);

        let atDateStaffAvailable = this.staffAvailable.filter(
          (i) => new Date(i.beginDateTime).setHours(0, 0, 0, 0) == atDate.setHours(0, 0, 0, 0) && i.status == "open"
        );
        return atDateStaffAvailable;
      }
    },
  },
});
